export default __webpack_public_path__ + "static/media/man-1-desktop.3652f394.jpg";